// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const Production_progress = {
    Released: 20578304,
    Processing: 20578305,
    Confirmed: 20578306,
    Created: 20578307,
    Proposed_by_MRP: 20578308,
    Planned_by_CRP: 20578309,
    Proposed_by_MRPMinusCRP: 20578310,
};
